import { useState } from 'react';
import { FullScreenModal } from '../components/shared/FullScreenModal';

export function useFullScreenModal({ onClose } = {}) {
  const [open, setOpen] = useState(false);

  const closeModal = () => {
    setOpen(false);
    onClose?.();
  };
  return {
    Trigger: ({ children, className }) => (
      <button className={`${className}`} onClick={() => setOpen((prev) => !prev)}>
        {children}
      </button>
    ),
    Modal: ({ title, children }) => (
      <FullScreenModal title={title} isOpen={open} onClose={closeModal}>
        {children}
      </FullScreenModal>
    ),
    setOpen,
    open,
  };
}
